import {useContext} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import {atomIconColors, atomIconSizes} from '@s-ui/react-atom-icon'
import Context from '@s-ui/react-context'
import ListBasic, {listItemsColors, listTitleSizes, listTypes} from '@adv-mt/mt-list-basic'
import IconCircleCheck from '@adv-mt/mt-svg-icons/lib/CircleCheck'
import IconCircleClose from '@adv-mt/mt-svg-icons/lib/CircleClose'
import IconThumbDownOutline from '@adv-mt/mt-svg-icons/lib/ThumbDownOutline'
import IconThumbUpOutline from '@adv-mt/mt-svg-icons/lib/ThumbUpOutline'
import TitleBasic, {titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

import {ARIA_PRESENTATION_ROLE, BASE_CLASS, LAYOUTS} from './settings.js'

const _mapStringToListBasicItem = stringList => {
  return stringList.map(s => {
    return {
      value: `<span class="${BASE_CLASS}-item">${s}</span>`
    }
  })
}

export default function ListFeatures({dislikes = [], layout, likes = []}) {
  const {i18n} = useContext(Context)

  const listBasicCommonProps = {
    maxColumns: 1,
    titleSize: listTitleSizes.xs,
    type: listTypes.ICON
  }

  const thumbDownIcon = () => <IconThumbDownOutline aria-hidden role={ARIA_PRESENTATION_ROLE} />
  const thumbUpIcon = () => <IconThumbUpOutline aria-hidden role={ARIA_PRESENTATION_ROLE} />

  const likesTitle = () => (
    <TitleBasic as={titleBasicTags.h4} icon={thumbUpIcon} size={titleBasicSizes.xxs} title={i18n.t('COMMON.PROS')} />
  )

  const dislikesTitle = () => (
    <TitleBasic as={titleBasicTags.h4} icon={thumbDownIcon} size={titleBasicSizes.xxs} title={i18n.t('COMMON.CONS')} />
  )

  const baseClassWithModifier = cx(BASE_CLASS, {
    [`${BASE_CLASS}--horizontal`]: layout === LAYOUTS.HORIZONTAL,
    [`${BASE_CLASS}--vertical`]: layout === LAYOUTS.VERTICAL
  })

  const listBasicLikesIcon = props => <IconCircleCheck {...props} aria-hidden role={ARIA_PRESENTATION_ROLE} />
  const listBasicDislikesIcon = props => <IconCircleClose {...props} aria-hidden role={ARIA_PRESENTATION_ROLE} />

  return (
    <div className={baseClassWithModifier}>
      <div className={`${BASE_CLASS}Section`}>
        <ListBasic
          title={likesTitle}
          {...listBasicCommonProps}
          itemsColor={listItemsColors.SUCCESS}
          icon={{
            color: atomIconColors.success,
            size: atomIconSizes.medium,
            type: listBasicLikesIcon
          }}
          items={_mapStringToListBasicItem(likes)}
        />
      </div>
      <div className={`${BASE_CLASS}Section`}>
        <ListBasic
          title={dislikesTitle}
          {...listBasicCommonProps}
          itemsColor={listItemsColors.ACCENT}
          icon={{
            color: atomIconColors.accent,
            size: atomIconSizes.medium,
            type: listBasicDislikesIcon
          }}
          items={_mapStringToListBasicItem(dislikes)}
        />
      </div>
    </div>
  )
}

ListFeatures.displayName = 'ListFeatures'
ListFeatures.propTypes = {
  dislikes: PropTypes.arrayOf(PropTypes.string).isRequired,
  layout: PropTypes.oneOf(Object.values(LAYOUTS)),
  likes: PropTypes.arrayOf(PropTypes.string).isRequired
}

export {LAYOUTS as listFeaturesLayouts}
